import { create } from "zustand";
import { persist } from "zustand/middleware";

import { createCategoriesSlice } from "./slices/categoriesSlice";
import { createProductsSlice } from "./slices/productsSlice";
import { createCartSlice } from "./slices/cartSlice";
import { createWishlistSlice } from "./slices/wishlistSlice";
import { createSearchSlice } from "./slices/searchSlice";
import { createAuthSlice } from "./slices/authSlice";
import { createCheckoutSlice } from "./slices/checkoutSlice";
import { createPaymentSlice } from "./slices/paymentSlice";
import { createOrdersSlice } from "./slices/ordersSlice";
import { createAddressesSlice } from "./slices/addressesSlice";
import { createNotificationsSlice } from "./slices/notificationsSlice";
import { createProductDetailSlice } from "./slices/productDetailSlice";
import { createOtpAuthSlice } from "./slices/otpAuthSlice";
import { createBannersSlice } from "./slices/bannersSlice";
import { createSubscriptionsSlice } from "./slices/subscriptionsSlice";

const useStore = create(
  persist(
    (set, get) => ({
      ...createCategoriesSlice(set, get),
      ...createProductsSlice(set, get),
      ...createCartSlice(set, get),
      ...createWishlistSlice(set, get),
      ...createSearchSlice(set, get),
      ...createAuthSlice(set, get),
      ...createCheckoutSlice(set, get),
      ...createPaymentSlice(set, get),
      ...createOrdersSlice(set, get),
      ...createAddressesSlice(set, get),
      ...createNotificationsSlice(set, get),
      ...createProductDetailSlice(set, get),
      ...createOtpAuthSlice(set, get),
      ...createBannersSlice(set, get),
      ...createSubscriptionsSlice(set, get),
    }),
    {
      name: "kissanfresh-storage",
      partialize: (state) => ({
        cart: state.cart,
        cart_count: state.cart_count,
        cart_total: state.cart_total,
        cart_gst_total: state.cart_gst_total,
        searchQuery: state.searchQuery,
        selectedCategory: state.selectedCategory,
        notifications: state.notifications,
        buyNowItem: state.buyNowItem,
        // user & isAuthenticated are NOT persisted.
        // They are re-validated on every app load via checkAuth() using the authToken cookie.
        // Persisting them caused stale profile data (name/phone) to show when the user is logged out.
      }),
    },
  ),
);

export default useStore;
